import {Directive, ElementRef, inject, input, OnInit, output} from '@angular/core';

@Directive({
    selector: '[appIntersectionObserver]',
    standalone: true
})
export class IntersectionObserverDirective implements OnInit {

    private hostEl = inject(ElementRef<HTMLElement>);

    public readonly intersectionThreshold = input(0.0);
    public readonly intersectionRootMargin = input('0px');
    public readonly intersectionRoot = input<HTMLElement | null>(null);
    public readonly intersectionMultiple = input(false);
    public readonly intersectionCallback = output<HTMLElement>();

    private intersectionOccurred = false;

    constructor() { }

    ngOnInit() {
        const options = {
            root: this.intersectionRoot(), // relative to document viewport
            rootMargin: this.intersectionRootMargin(), // margin around root. Values are similar to css property. Unitless values not allowed
            threshold: this.intersectionThreshold() // visible amount of item shown in relation to root
        };
        const observer = new IntersectionObserver(this.observerCallback.bind(this), options);
        observer.observe(this.hostEl.nativeElement);
    }

    observerCallback(entries: IntersectionObserverEntry[], observer: IntersectionObserver) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                this.intersectionOccurred = true;
                if (!this.intersectionMultiple()) {
                    observer.unobserve(this.hostEl.nativeElement);
                }
                this.intersectionCallback.emit(this.hostEl.nativeElement);
            }
        });
    }
}
